import createCachedSelector from "re-reselect";

import { getSearchedLeg, getTripDuration } from "@app/helpers/udm";

import { getSearch, getTrips, getTripsSegments } from "../state-accessors";
import { getLegCardById } from "./get-leg-card-by-id";

export const getJourneyIdOfLongestTripFromLegCardId = createCachedSelector(
  getSearch,
  getTrips,
  getTripsSegments,
  getLegCardById,
  (search, trips, trips_segments, trip_ids = []) => {
    let max_duration = 0;
    let max_duration_journey_id: string | undefined;

    trip_ids.forEach(trip_id => {
      const trip = trips[trip_id];
      // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const searched_leg = getSearchedLeg(search, trip);
      const trip_segment_ids = searched_leg?.segment_ids || [];
      const trip_segments = trip_segment_ids.map(
        segment_id => trips_segments[segment_id]
      );
      // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const duration = getTripDuration(trip_segments);
      if (duration > max_duration) {
        // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        max_duration_journey_id = trip.journey_id;
        max_duration = duration;
      }
    });

    return max_duration_journey_id!;
  }
)((_, leg_card_id) => leg_card_id);
